import { Table } from '../Enums/Table.enum';
import { HealthData } from '../Enums/HealthData.enum';

type Key = Table | HealthData;

export const TABLE_COLORS: { [key in Key]?: any } = {
	[Table.WEIGHT]: {
		colors: [
			{
				color: 'rgb(223,50,24)',
				textColor: '#fff',
				weight: {
					from: 0,
					to: 40,
				},
			},
			{
				color: '#619612',
				textColor: '#fff',
				weight: {
					from: 40,
					to: 100,
				},
			},
			{
				color: 'rgb(223,50,24)',
				textColor: '#fff',
				weight: {
					from: 101,
					to: 999,
				},
			},
		],
	},
	[Table.BLOOD_GLUCOSE]: {
		colors: [
			{
				color: 'rgb(223,50,24)',
				textColor: '#fff',
				bloodGlucose: {
					from: 0,
					to: 69,
				},
			},
			{
				color: '#619612',
				textColor: '#fff',
				bloodGlucose: {
					from: 70,
					to: 181,
				},
			},
			{
				color: 'rgb(223,50,24)',
				textColor: '#fff',
				bloodGlucose: {
					from: 182,
					to: 999,
				},
			},
		],
	},
	[Table.BLOOD_PRESSURE]: {
		colors: [
			{
				color: 'rgb(223,50,24)',
				textColor: '#fff',
				blood_pressure_systolic: {
					from: 0,
					to: 89,
				},
				blood_pressure_diastolic: {
					from: 0,
					to: 58,
				},
			},
			{
				color: '#619612',
				textColor: '#fff',
				blood_pressure_systolic: {
					from: 90,
					to: 141,
				},
				blood_pressure_diastolic: {
					from: 59,
					to: 91,
				},
			},
			{
				color: 'rgb(223,50,24)',
				textColor: '#fff',
				blood_pressure_systolic: {
					from: 142,
					to: 999,
				},
				blood_pressure_diastolic: {
					from: 92,
					to: 999,
				},
			},
		],
	},
	[HealthData.BLOOD_GLUCOSE_EXTRA]: {
		colors: [
			{
				color: 'rgb(223,50,24)',
				textColor: '#fff',
				bloodGlucose: {
					from: 0,
					to: 69,
				},
			},
			{
				color: '#619612',
				textColor: '#fff',
				bloodGlucose: {
					from: 70,
					to: 201,
				},
			},
			{
				color: 'rgb(223,50,24)',
				textColor: '#fff',
				bloodGlucose: {
					from: 202,
					to: 999,
				},
			},
		],
	},
	[HealthData.BLOOD_GLUCOSE_FASTING]: {
		colors: [
			{
				color: 'rgb(223,50,24)',
				textColor: '#fff',
				bloodGlucose: {
					from: 0,
					to: 69,
				},
			},
			{
				color: '#619612',
				textColor: '#fff',
				bloodGlucose: {
					from: 70,
					to: 130,
				},
			},
			{
				color: 'rgb(223,50,24)',
				textColor: '#fff',
				bloodGlucose: {
					from: 131,
					to: 999,
				},
			},
		],
	},
	[HealthData.BLOOD_GLUCOSE_BEFORE_BREAKFAST]: {
		colors: [
			{
				color: 'rgb(223,50,24)',
				textColor: '#fff',
				bloodGlucose: {
					from: 0,
					to: 69,
				},
			},
			{
				color: '#619612',
				textColor: '#fff',
				bloodGlucose: {
					from: 70,
					to: 201,
				},
			},
			{
				color: 'rgb(223,50,24)',
				textColor: '#fff',
				bloodGlucose: {
					from: 202,
					to: 999,
				},
			},
		],
	},
	[HealthData.BLOOD_GLUCOSE_BEFORE_LUNCH]: {
		colors: [
			{
				color: 'rgb(223,50,24)',
				textColor: '#fff',
				bloodGlucose: {
					from: 0,
					to: 69,
				},
			},
			{
				color: '#619612',
				textColor: '#fff',
				bloodGlucose: {
					from: 70,
					to: 201,
				},
			},
			{
				color: 'rgb(223,50,24)',
				textColor: '#fff',
				bloodGlucose: {
					from: 202,
					to: 999,
				},
			},
		],
	},
	[HealthData.BLOOD_GLUCOSE_BEFORE_DINNER]: {
		colors: [
			{
				color: 'rgb(223,50,24)',
				textColor: '#fff',
				bloodGlucose: {
					from: 0,
					to: 69,
				},
			},
			{
				color: '#619612',
				textColor: '#fff',
				bloodGlucose: {
					from: 70,
					to: 999,
				},
			},
		],
	},
	[HealthData.BLOOD_GLUCOSE_AFTER_BREAKFAST]: {
		colors: [
			{
				color: 'rgb(223,50,24)',
				textColor: '#fff',
				bloodGlucose: {
					from: 0,
					to: 69,
				},
			},
			{
				color: '#619612',
				textColor: '#fff',
				bloodGlucose: {
					from: 70,
					to: 180,
				},
			},
			{
				color: 'rgb(223,50,24)',
				textColor: '#fff',
				bloodGlucose: {
					from: 181,
					to: 999,
				},
			},
		],
	},
	[HealthData.BLOOD_GLUCOSE_AFTER_LUNCH]: {
		colors: [
			{
				color: 'rgb(223,50,24)',
				textColor: '#fff',
				bloodGlucose: {
					from: 0,
					to: 69,
				},
			},
			{
				color: '#619612',
				textColor: '#fff',
				bloodGlucose: {
					from: 70,
					to: 180,
				},
			},
			{
				color: 'rgb(223,50,24)',
				textColor: '#fff',
				bloodGlucose: {
					from: 181,
					to: 999,
				},
			},
		],
	},
	[HealthData.BLOOD_GLUCOSE_AFTER_DINNER]: {
		colors: [
			{
				color: 'rgb(223,50,24)',
				textColor: '#fff',
				bloodGlucose: {
					from: 0,
					to: 69,
				},
			},
			{
				color: '#619612',
				textColor: '#fff',
				bloodGlucose: {
					from: 70,
					to: 180,
				},
			},
			{
				color: 'rgb(223,50,24)',
				textColor: '#fff',
				bloodGlucose: {
					from: 181,
					to: 999,
				},
			},
		],
	},
	[HealthData.BLOOD_GLUCOSE_BEFORE_SLEEP]: {
		colors: [
			{
				color: 'rgb(223,50,24)',
				textColor: '#fff',
				bloodGlucose: {
					from: 0,
					to: 69,
				},
			},
			{
				color: '#619612',
				textColor: '#fff',
				bloodGlucose: {
					from: 70,
					to: 140,
				},
			},
			{
				color: 'rgb(223,50,24)',
				textColor: '#fff',
				bloodGlucose: {
					from: 141,
					to: 999,
				},
			},
		],
	},
	[HealthData.BLOOD_GLUCOSE_BEFORE_WORKOUT]: {
		colors: [
			{
				color: 'rgb(223,50,24)',
				textColor: '#fff',
				bloodGlucose: {
					from: 0,
					to: 69,
				},
			},
			{
				color: '#619612',
				textColor: '#fff',
				bloodGlucose: {
					from: 70,
					to: 201,
				},
			},
			{
				color: 'rgb(223,50,24)',
				textColor: '#fff',
				bloodGlucose: {
					from: 202,
					to: 999,
				},
			},
		],
	},
	[HealthData.BLOOD_GLUCOSE_3AM]: {
		colors: [
			{
				color: 'rgb(223,50,24)',
				textColor: '#fff',
				bloodGlucose: {
					from: 0,
					to: 69,
				},
			},
			{
				color: '#619612',
				textColor: '#fff',
				bloodGlucose: {
					from: 70,
					to: 201,
				},
			},
			{
				color: 'rgb(223,50,24)',
				textColor: '#fff',
				bloodGlucose: {
					from: 202,
					to: 999,
				},
			},
		],
	},
	[Table.QUESTIONNAIRE_RESULTS]: {
		colors: [
			{
				color: '#90b767',
				textColor: '#fff',
				['esasCelkovapohoda']: {
					from: 0,
					to: 0,
				},
				['esasBolest']: {
					from: 0,
					to: 0,
				},
				['esasUnava']: {
					from: 0,
					to: 0,
				},
				['esasOspalost']: {
					from: 0,
					to: 0,
				},
				['esasNevolnost']: {
					from: 0,
					to: 0,
				},
				['esasNechutenstvi']: {
					from: 0,
					to: 0,
				},
				['esasDusnost']: {
					from: 0,
					to: 0,
				},
				['esasDeprese']: {
					from: 0,
					to: 0,
				},
				['esasUzkost']: {
					from: 0,
					to: 0,
				},
				['esasJinyproblem']: {
					from: 0,
					to: 0,
				},
				['psychoStrach,tisen,uzkost']: {
					from: 0,
					to: 0,
				},
				['psychoDepresivita']: {
					from: 0,
					to: 0,
				},
				['psychoZvladanisituace']: {
					from: 0,
					to: 0,
				},
			},
			{
				color: '#b4c763',
				textColor: '#fff',
				['esasCelkovapohoda']: {
					from: 1,
					to: 1,
				},
				['esasBolest']: {
					from: 1,
					to: 1,
				},
				['esasUnava']: {
					from: 1,
					to: 1,
				},
				['esasOspalost']: {
					from: 1,
					to: 1,
				},
				['esasNevolnost']: {
					from: 1,
					to: 1,
				},
				['esasNechutenstvi']: {
					from: 1,
					to: 1,
				},
				['esasDusnost']: {
					from: 1,
					to: 1,
				},
				['esasDeprese']: {
					from: 1,
					to: 1,
				},
				['esasUzkost']: {
					from: 1,
					to: 1,
				},
				['esasJinyproblem']: {
					from: 1,
					to: 1,
				},
				['psychoStrach,tisen,uzkost']: {
					from: 1,
					to: 1,
				},
				['psychoDepresivita']: {
					from: 1,
					to: 1,
				},
				['psychoZvladanisituace']: {
					from: 1,
					to: 1,
				},
			},
			{
				color: '#aabf5f',
				textColor: '#fff',
				['esasCelkovapohoda']: {
					from: 2,
					to: 2,
				},
				['esasBolest']: {
					from: 2,
					to: 2,
				},
				['esasUnava']: {
					from: 2,
					to: 2,
				},
				['esasOspalost']: {
					from: 2,
					to: 2,
				},
				['esasNevolnost']: {
					from: 2,
					to: 2,
				},
				['esasNechutenstvi']: {
					from: 2,
					to: 2,
				},
				['esasDusnost']: {
					from: 2,
					to: 2,
				},
				['esasDeprese']: {
					from: 2,
					to: 2,
				},
				['esasUzkost']: {
					from: 2,
					to: 2,
				},
				['esasJinyproblem']: {
					from: 2,
					to: 2,
				},
				['psychoStrach,tisen,uzkost']: {
					from: 2,
					to: 2,
				},
				['psychoDepresivita']: {
					from: 2,
					to: 2,
				},
				['psychoZvladanisituace']: {
					from: 2,
					to: 2,
				},
			},
			{
				color: '#c7ca63',
				textColor: '#fff',
				['esasCelkovapohoda']: {
					from: 3,
					to: 3,
				},
				['esasBolest']: {
					from: 3,
					to: 3,
				},
				['esasUnava']: {
					from: 3,
					to: 3,
				},
				['esasOspalost']: {
					from: 3,
					to: 3,
				},
				['esasNevolnost']: {
					from: 3,
					to: 3,
				},
				['esasNechutenstvi']: {
					from: 3,
					to: 3,
				},
				['esasDusnost']: {
					from: 3,
					to: 3,
				},
				['esasDeprese']: {
					from: 3,
					to: 3,
				},
				['esasUzkost']: {
					from: 3,
					to: 3,
				},
				['esasJinyproblem']: {
					from: 3,
					to: 3,
				},
				['psychoStrach,tisen,uzkost']: {
					from: 3,
					to: 3,
				},
				['psychoDepresivita']: {
					from: 3,
					to: 3,
				},
				['psychoZvladanisituace']: {
					from: 3,
					to: 3,
				},
			},
			{
				color: '#d7bd55',
				textColor: '#fff',
				['esasCelkovapohoda']: {
					from: 4,
					to: 4,
				},
				['esasBolest']: {
					from: 4,
					to: 4,
				},
				['esasUnava']: {
					from: 4,
					to: 4,
				},
				['esasOspalost']: {
					from: 4,
					to: 4,
				},
				['esasNevolnost']: {
					from: 4,
					to: 4,
				},
				['esasNechutenstvi']: {
					from: 4,
					to: 4,
				},
				['esasDusnost']: {
					from: 4,
					to: 4,
				},
				['esasDeprese']: {
					from: 4,
					to: 4,
				},
				['esasUzkost']: {
					from: 4,
					to: 4,
				},
				['esasJinyproblem']: {
					from: 4,
					to: 4,
				},
				['psychoStrach,tisen,uzkost']: {
					from: 4,
					to: 4,
				},
				['psychoDepresivita']: {
					from: 4,
					to: 4,
				},
				['psychoZvladanisituace']: {
					from: 4,
					to: 4,
				},
			},
			{
				color: '#d8aa4f',
				textColor: '#fff',
				['esasCelkovapohoda']: {
					from: 5,
					to: 5,
				},
				['esasBolest']: {
					from: 5,
					to: 5,
				},
				['esasUnava']: {
					from: 5,
					to: 5,
				},
				['esasOspalost']: {
					from: 5,
					to: 5,
				},
				['esasNevolnost']: {
					from: 5,
					to: 5,
				},
				['esasNechutenstvi']: {
					from: 5,
					to: 5,
				},
				['esasDusnost']: {
					from: 5,
					to: 5,
				},
				['esasDeprese']: {
					from: 5,
					to: 5,
				},
				['esasUzkost']: {
					from: 5,
					to: 5,
				},
				['esasJinyproblem']: {
					from: 5,
					to: 5,
				},
				['psychoStrach,tisen,uzkost']: {
					from: 5,
					to: 5,
				},
				['psychoDepresivita']: {
					from: 5,
					to: 5,
				},
				['psychoZvladanisituace']: {
					from: 5,
					to: 5,
				},
			},
			{
				color: '#ce734e',
				textColor: '#fff',
				['esasCelkovapohoda']: {
					from: 6,
					to: 6,
				},
				['esasBolest']: {
					from: 6,
					to: 6,
				},
				['esasUnava']: {
					from: 6,
					to: 6,
				},
				['esasOspalost']: {
					from: 6,
					to: 6,
				},
				['esasNevolnost']: {
					from: 6,
					to: 6,
				},
				['esasNechutenstvi']: {
					from: 6,
					to: 6,
				},
				['esasDusnost']: {
					from: 6,
					to: 6,
				},
				['esasDeprese']: {
					from: 6,
					to: 6,
				},
				['esasUzkost']: {
					from: 6,
					to: 6,
				},
				['esasJinyproblem']: {
					from: 6,
					to: 6,
				},
				['psychoStrach,tisen,uzkost']: {
					from: 6,
					to: 6,
				},
				['psychoDepresivita']: {
					from: 6,
					to: 6,
				},
				['psychoZvladanisituace']: {
					from: 6,
					to: 6,
				},
			},
			{
				color: '#ce734e',
				textColor: '#fff',
				['esasCelkovapohoda']: {
					from: 7,
					to: 7,
				},
				['esasBolest']: {
					from: 7,
					to: 7,
				},
				['esasUnava']: {
					from: 7,
					to: 7,
				},
				['esasOspalost']: {
					from: 7,
					to: 7,
				},
				['esasNevolnost']: {
					from: 7,
					to: 7,
				},
				['esasNechutenstvi']: {
					from: 7,
					to: 7,
				},
				['esasDusnost']: {
					from: 7,
					to: 7,
				},
				['esasDeprese']: {
					from: 7,
					to: 7,
				},
				['esasUzkost']: {
					from: 7,
					to: 7,
				},
				['esasJinyproblem']: {
					from: 7,
					to: 7,
				},
				['psychoStrach,tisen,uzkost']: {
					from: 7,
					to: 7,
				},
				['psychoDepresivita']: {
					from: 7,
					to: 7,
				},
				['psychoZvladanisituace']: {
					from: 7,
					to: 7,
				},
			},
			{
				color: '#c76352',
				textColor: '#fff',
				['esasCelkovapohoda']: {
					from: 8,
					to: 8,
				},
				['esasBolest']: {
					from: 8,
					to: 8,
				},
				['esasUnava']: {
					from: 8,
					to: 8,
				},
				['esasOspalost']: {
					from: 8,
					to: 8,
				},
				['esasNevolnost']: {
					from: 8,
					to: 8,
				},
				['esasNechutenstvi']: {
					from: 8,
					to: 8,
				},
				['esasDusnost']: {
					from: 8,
					to: 8,
				},
				['esasDeprese']: {
					from: 8,
					to: 8,
				},
				['esasUzkost']: {
					from: 8,
					to: 8,
				},
				['esasJinyproblem']: {
					from: 8,
					to: 8,
				},
				['psychoStrach,tisen,uzkost']: {
					from: 8,
					to: 8,
				},
				['psychoDepresivita']: {
					from: 8,
					to: 8,
				},
				['psychoZvladanisituace']: {
					from: 8,
					to: 8,
				},
			},
			{
				color: '#c35156',
				textColor: '#fff',
				['esasCelkovapohoda']: {
					from: 9,
					to: 9,
				},
				['esasBolest']: {
					from: 9,
					to: 9,
				},
				['esasUnava']: {
					from: 9,
					to: 9,
				},
				['esasOspalost']: {
					from: 9,
					to: 9,
				},
				['esasNevolnost']: {
					from: 9,
					to: 9,
				},
				['esasNechutenstvi']: {
					from: 9,
					to: 9,
				},
				['esasDusnost']: {
					from: 9,
					to: 9,
				},
				['esasDeprese']: {
					from: 9,
					to: 9,
				},
				['esasUzkost']: {
					from: 9,
					to: 9,
				},
				['esasJinyproblem']: {
					from: 9,
					to: 9,
				},
				['psychoStrach,tisen,uzkost']: {
					from: 9,
					to: 9,
				},
				['psychoDepresivita']: {
					from: 9,
					to: 9,
				},
				['psychoZvladanisituace']: {
					from: 9,
					to: 9,
				},
			},
			{
				color: '#b75562',
				textColor: '#fff',
				['esasCelkovapohoda']: {
					from: 10,
					to: 10,
				},
				['esasBolest']: {
					from: 10,
					to: 10,
				},
				['esasUnava']: {
					from: 10,
					to: 10,
				},
				['esasOspalost']: {
					from: 10,
					to: 10,
				},
				['esasNevolnost']: {
					from: 10,
					to: 10,
				},
				['esasNechutenstvi']: {
					from: 10,
					to: 10,
				},
				['esasDusnost']: {
					from: 10,
					to: 10,
				},
				['esasDeprese']: {
					from: 10,
					to: 10,
				},
				['esasUzkost']: {
					from: 10,
					to: 10,
				},
				['esasJinyproblem']: {
					from: 10,
					to: 10,
				},
				['psychoStrach,tisen,uzkost']: {
					from: 10,
					to: 10,
				},
				['psychoDepresivita']: {
					from: 10,
					to: 10,
				},
				['psychoZvladanisituace']: {
					from: 10,
					to: 10,
				},
			},
			{
				color: 'rgb(223,50,24)',
				textColor: '#fff',
				meddiBabyLatamVaginalBleeding: {
					from: 1,
					to: 1,
				},
				meddiBabyLatamUrinaryTractInfection: {
					from: 1,
					to: 1,
				},
				meddiBabyLatamVaginalInfection: {
					from: 1,
					to: 1,
				},
				meddiBabyLatamVomiting: {
					from: 1,
					to: 1,
				},
				meddiBabyLatamDiarrhoea: {
					from: 1,
					to: 1,
				},
				meddiBabyLatamMedicaments: {
					from: 1,
					to: 1,
				},
				meddiBabyLatamAmnioticFluidLeak: {
					from: 1,
					to: 1,
				},
				meddiBabyLatamSwelling: {
					from: 1,
					to: 1,
				},
				meddiBabyLatamUterineContractions: {
					from: 1,
					to: 1,
				},
				meddiBabyLatamHypertensionSymptoms: {
					from: 1,
					to: 1,
				},
				meddiBabyLatamBreastSelfAssessment: {
					from: 1,
					to: 1,
				},
				meddiBabyLatamFetalMovements: {
					from: 0,
					to: 0,
				},
				meddiBabyLatamTemperature: {
					from: 0,
					to: 0,
				},
				meddiBabyLatamRouteOfDelivery: {
					from: 1,
					to: 1,
				},
				meddiBabyLatamLochia: {
					from: 1,
					to: 1,
				},
				meddiBabyLatamGlycemia: {
					from: 0,
					to: 69,
				},
				meddiBabyLatamLowerAbdomenPain: {
					from: 1,
					to: 1,
				},
			},
			{
				color: 'rgb(223,50,24)',
				textColor: '#fff',
				meddiBabyLatamGlycemia: {
					from: 96,
					to: 999,
				},
			},
			{
				color: '#619612',
				textColor: '#fff',
				meddiBabyLatamVaginalBleeding: {
					from: 0,
					to: 0,
				},
				meddiBabyLatamUrinaryTractInfection: {
					from: 0,
					to: 0,
				},
				meddiBabyLatamVaginalInfection: {
					from: 0,
					to: 0,
				},
				meddiBabyLatamVomiting: {
					from: 0,
					to: 0,
				},
				meddiBabyLatamDiarrhoea: {
					from: 0,
					to: 0,
				},
				meddiBabyLatamMedicaments: {
					from: 0,
					to: 0,
				},
				meddiBabyLatamAmnioticFluidLeak: {
					from: 0,
					to: 0,
				},
				meddiBabyLatamSwelling: {
					from: 0,
					to: 0,
				},
				meddiBabyLatamUterineContractions: {
					from: 0,
					to: 0,
				},
				meddiBabyLatamHypertensionSymptoms: {
					from: 0,
					to: 0,
				},
				meddiBabyLatamBreastSelfAssessment: {
					from: 0,
					to: 0,
				},
				meddiBabyLatamFetalMovements: {
					from: 1,
					to: 1,
				},
				meddiBabyLatamTemperature: {
					from: 1,
					to: 1,
				},
				meddiBabyLatamRouteOfDelivery: {
					from: 0,
					to: 0,
				},
				meddiBabyLatamLochia: {
					from: 0,
					to: 0,
				},
				meddiBabyLatamGlycemia: {
					from: 70,
					to: 95,
				},
				meddiBabyLatamLowerAbdomenPain: {
					from: 0,
					to: 0,
				},
			},
		],
	},
};
